import React, { useEffect} from 'react';
import {message,Upload, } from 'antd'
import axios from 'axios';
import {BASE, } from '../../../api';

const CancelToken = axios.CancelToken;
const source = CancelToken.source();
let cancel = null;

const App = (props) => {
    const {from, upButton, uploadFileType, uploadFileSize, setpercent, setPercentShow, setFileUrl, show, upname} = props;
      console.log('uploadfile - ', show, cancel)
      console.log('uploadFileSize - ', uploadFileSize)

    useEffect(() => {
      console.log('uploadfile2222 - ', show, cancel)
      if(!show && cancel!=null){
        console.log('结束请求', source);
        cancel('Upload canceled by the user.');
      }
    }, [show]);

  /**
   * @en-US International configuration
   * @zh-CN 国际化配置
   * */
  const beforeUpload = async (file) => {
    // 获取文件信息
    console.log('file==================', file)

    let fileType = file.name;
    var index = fileType.lastIndexOf('.');
    fileType = uploadFileType.indexOf(fileType.substring(index + 1, fileType.lenght).toLowerCase()) >= 0;

    // 校验
    if (!fileType) {
      message.error('只能上传 '+uploadFileType+' 格式文件!');
    }
    if (file.size > uploadFileSize) {
      message.error('文件大小超过 '+uploadFileSize/1024/1024+'M');
      return false;
    }
    
    return fileType;
  };

  

    const uploadProps = {
        action: BASE+"uploadfile.php?token="+localStorage.getItem('token_k'),
        name: 'file',
        accept: uploadFileType,
        multiple: false,
        showUploadList: false,
        beforeUpload: beforeUpload,
        onStart(file) {
            console.log('onStart', file, file.name);
          },
        onChange(info) {
            console.log('info ---------- ', info)
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                var response = info.file.response;
                console.log('info -2---------- ',typeof(response), response)
                if(response.code == 9){
                  setFileUrl(BASE+response.url);
                  message.success(`${info.file.name} 上传成功`);
                }
                else
                  message.error(response.msg);
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name} 上传失败`);
            }
        },
    };

  
    return (
        <Upload {...uploadProps}>
            {upButton}
        </Upload>

    )
}

export default App